<template>
  <div>
    <span class="sr-only">{{ label }}</span>
    <svg :width="width" :height="height" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 40 40" fill="none">
      <path
        v-if="includeText"
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M18.0365 38.1935C18.0365 39.2071 17.1876 40 15.9103 40C14.3338 40 13.6708 39.2071 13.59 38.1035H14.6248C14.6976 38.6921 14.932 39.1826 15.9103 39.1826C16.549 39.1826 17.0017 38.8229 17.0017 38.2834C17.0017 37.7439 16.7349 37.5395 15.7971 37.3842C14.4146 37.1962 13.7597 36.7711 13.7597 35.6757C13.7597 34.7193 14.5682 34 15.7728 34C17.0179 34 17.7617 34.5722 17.8748 35.6921H16.8885C16.7834 35.079 16.4358 34.8174 15.7728 34.8174C15.118 34.8174 14.7784 35.1362 14.7784 35.5858C14.7784 36.0599 14.9724 36.297 15.9749 36.4441C17.3332 36.6322 18.0365 37.0245 18.0365 38.1935ZM1.75 39.9184H2.82526V37.5233H4.79792V36.6813H2.82526V34.9402H5.33151V34.0737H1.75V39.9184ZM6.29494 39.9184H7.37829V34.0737H6.29494V39.9184ZM9.81306 39.9184H8.7378V34.0737H10.6781C11.9474 34.0737 12.8367 34.5969 12.8367 35.7903L12.8325 35.957C12.7798 36.7845 12.2348 37.2139 11.5513 37.3925L13.1763 39.9184H12.0121L10.5003 37.556H9.81306V39.9184ZM9.81308 36.7793V34.9155H10.6781C11.3292 34.9155 11.7335 35.121 11.7743 35.7125L11.7777 35.8474C11.7777 36.4687 11.3977 36.7793 10.6781 36.7793H9.81308ZM20.051 39.9184H21.1343V34.932H22.7432V34.0737H18.4421V34.932H20.051V39.9184ZM26.0849 39.9184H25.0743L27.0066 34.0737H28.4133L30.3213 39.9184H29.2056L28.7448 38.4715H26.5376L26.0849 39.9184ZM27.6452 34.9646L28.4941 37.6785H26.7882L27.6452 34.9646ZM32.3113 39.9184H31.228V34.0737H32.3113V39.9184ZM33.671 39.9184H35.4092C37.3787 39.9184 38.3582 38.7787 38.4141 37.157L38.4167 36.9347C38.4167 35.2345 37.4384 34.0737 35.4253 34.0737H33.671V39.9184ZM34.7461 34.9319V39.0599H35.3767C36.6703 39.0599 37.2928 38.3079 37.2928 37.0163L37.2906 36.818C37.2514 35.6388 36.6784 34.9319 35.3687 34.9319H34.7461Z"
        :fill="fillColor"
      />
      <path
        d="M19.9999 8.5C22.0073 8.5 22.8749 9.06555 22.8749 10.2H17.1249C17.1249 9.06555 17.9925 8.5 19.9999 8.5Z"
        :fill="fillColor"
      />
      <path
        d="M20.7499 13.1333H19.2499V15.7H16.6251V17.1667H19.2499V19.7333H20.7499V17.1667H23.3751V15.7H20.7499V13.1333Z"
        :fill="fillColor"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M20.0001 32C28.8366 32 36.0001 24.8366 36.0001 16C36.0001 7.16344 28.8366 0 20.0001 0C11.1635 0 4.00006 7.16344 4.00006 16C4.00006 24.8366 11.1635 32 20.0001 32ZM27.7782 10.2L23.8749 10.2C23.8749 8.40111 22.4925 7.5 19.9999 7.5C17.5073 7.5 16.1249 8.40111 16.1249 10.2L12.2218 10.2C11.547 10.2 11 10.747 11 11.4218V21.4448C11 22.1196 11.547 22.6667 12.2218 22.6667H27.7782C28.453 22.6667 29 22.1196 29 21.4448V11.4218C29 10.747 28.453 10.2 27.7782 10.2Z"
        :fill="fillColor"
      />
    </svg>
  </div>
</template>

<script lang="ts">
export default {
  name: 'FirstAidBadge',
  props: {
    width: {
      type: Number,
      default: 40,
    },
    height: {
      type: Number,
      default: 40,
    },
    active: {
      type: Boolean,
      default: true,
    },
    hasSimpleLabel: {
      type: Boolean,
      default: false,
    },
    includeText: {
      type: Boolean,
      default: true,
    },
    color: {
      type: String,
      default: '',
    },
  },
  computed: {
    fillColor(): string {
      return this.color || (this.active ? '#CE1B04' : '#B4B5B7');
    },
    label() {
      if (this.hasSimpleLabel) {
        return 'First Aid';
      }

      return `This user ${this.active ? 'has' : 'does not have'} First Aid training`;
    },
  },
};
</script>
